import React, { useState } from "react";
import CreatePromoForm from "../component/CreatePromoForm";
import useAxiosConfig from "../config/AxiosConfig";
import { Snackbar, Alert } from "@mui/material";
const CreatePromotion = () => {
  const axiosInstance = useAxiosConfig();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleCloseSnackbar = () => {
    setSuccessMessage("");
    setErrorMessage("");
  };

  const createPromotion = async (data) => {
    try {
      // Create new promotion
      const response = await axiosInstance.post(
        "api/admin/create-promo-code",
        data
      );
      if (
        response.status === 201 ||
        (response.status === 200 && response.data.status === true)
      ) {
        setSuccessMessage("Promo code created successfully");
      } else {
        setErrorMessage(response.data.message || "Error creating promo code");
      }
    } catch (error) {
      console.error("Error creating/updating promo code:", error);
      setErrorMessage(
        error.response?.data?.message || "Error creating/updating promo code"
      );
    }
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center mt-8">
      <CreatePromoForm title="Create Promotion" onSubmit={createPromotion} />
      <Snackbar
        open={!!successMessage}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {successMessage}
        </Alert>
      </Snackbar>
      <Snackbar
        open={!!errorMessage}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default CreatePromotion;
